import MicroModal from "micromodal";

let lastClickedButton = null;

document
  .querySelectorAll('[data-micromodal-trigger="modal-contact"]')
  .forEach((button) => {
    button.addEventListener("click", () => {
      lastClickedButton = button;
    });
  });

MicroModal.init({
  onShow: function (modal) {
    if (!lastClickedButton) return;

    const contactName = lastClickedButton.getAttribute("data-contact");
    const email = lastClickedButton.getAttribute("data-email");

    // Replace text in the modal title
    const nameEl = modal.querySelector("#contact-modal-name");
    if (nameEl && contactName) {
      nameEl.textContent = contactName;
    }

    // Set hidden input value
    const emailInput = modal.querySelector("#input_2_10");
    if (emailInput && email) {
      emailInput.value = email;
    }
  },
});
